const EditarPrecoTintaController = ControllerBase.extend({
    name: "EditarPrecoTintaController",

    framework: "knockout",

    ajax: function() {

        return {
            url: "/Orcamento/_EditarPrecoTinta",
            type: "post",
            cache: false
        };
    },

    aposBinding: function () {
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    antesBinding: function() {

        if (this.itemOrcamento) {
            this.setModel(this.itemOrcamento.toJSON());

            var codigoTinta = this.model.CodigoTinta();
            var orcamento = this.itemOrcamento.orcamento.toJSON();
            
            var itens = [];
            orcamento.ItensOrcamento.forEach(function (value) {
                if (value.CodigoTinta === codigoTinta) {
                    itens.push(value);
                }
            });

            this.model.Itens = itens;
        }
    },

    salvar: function() {


        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirPrecoTinta",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                definirPrecoTinta: {
                    IdentificadorOrcamento: this.model.IdentificadorOrcamento(),
                    Identificador: this.model.Identificador(),
                    Preco: this.model.PrecoTinta()
                }
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                self.itemOrcamento.atualizarRetorno(data);

                global.showSuccessMessage("Preço tinta definido com sucesso");

                if (self.finalizarCallback) {
                    self.finalizarCallback();
                }

            }
        });

    }

})

window.EditarPrecoTintaController = EditarPrecoTintaController

export {
    EditarPrecoTintaController
}